import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { htmlStyle } from '../../styles';
import DestinationCard, { destinationPropTypes } from '../DestinationCard';

const Container = styled.div`
  ${tw`flex flex-col mb-abs6
  md:flex-row`};
`;
const DestinationCardDescription = styled.div`
  ${tw`mt-def md:ml-gutter`};
  ${htmlStyle}
`;

const DestinationSection = ({
  customClickHandler,
  description,
  destination,
}) => (
  <Container>
    <DestinationCard
      customClickHandler={customClickHandler}
      destination={destination}
      isCloaked
    />
    <DestinationCardDescription
      dangerouslySetInnerHTML={{ __html: description }}
    />
  </Container>
);

DestinationSection.propTypes = {
  customClickHandler: PropTypes.func,
  description: PropTypes.string,
  destination: destinationPropTypes,
};

export { DestinationSection };
